<template>
    <HLCardLayout :scale="(isTabletOrPhone)?1:(isXlDevice)?0.4:0.7" :minHeight="(isSmAndUpDevice)?'600':null" :horizontalMargin="isSmAndUpDevice">
        <template #content>
            <HLCheckLogin @cancel="onDoNormalEventCheck" @doQRLogin="onGoToLogin"/>
        </template>
    </HLCardLayout>
</template>

<script>
import {layoutMixin} from "../../utils/layout-mixin";
import {settingsMixin} from "../../utils/settings-mixin";
import {qrLoginMixin} from "../../utils/qrlogin-mixin";
import HLCardLayout from "../../components/dashboard/HLCardLayout.vue";
import HLCheckLogin from "../../components/auth/HLCheckLogin.vue";
export default {
    mixins: [layoutMixin,settingsMixin,qrLoginMixin],
    components:{
        HLCheckLogin,
        HLCardLayout,
    },
    data(){
        return {

        }
    },
    computed: {

    },
    methods: {
        onGoToLogin() {
            let qrAtStart = this.getQrData();
            this.goToLogin({'d':qrAtStart});
        },
        onDoNormalEventCheck(){
            // the scanned QR wins over a remembered event: the list reads it for the current user
            this.goToEventList({'d':this.getQrData()});
        }
    },
    created(){
        if(this.isAutoLogin()){
            let qrAtStart = this.getQrData();
            this.goToLogin({'d':qrAtStart});
        }
    }
}
</script>

<style scoped>

.container{
    max-width: 600px;
}
</style>